import { KvixThemeVariantContext } from "@kvix/ui";
import React, { useContext, useEffect } from "react";
import { Footer } from "../../Footer";
import { Page } from "../../partials/Page";
import { ScrollArea } from "./components/ScrollArea";

const AboutPage: React.FC = () => {
  const themeContext = useContext(KvixThemeVariantContext);
  const initialTheme = themeContext.variant;

  themeContext.setVariant("light");

  useEffect(() => {
    return () => {
      themeContext.setVariant(initialTheme);
    };
  }, []);

  return (
    <Page>
      <ScrollArea />
      <Footer />
    </Page>
  );
};

export default AboutPage;
